// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_fe-0";
export var actionModalContentContainer = "_fe-1";
export var createTagButton = "_fe-2";
export var footerContainer = "_fe-7";
export var fullWidthDivider = "_fe-3";
export var hasCreateTagButton = "_fe-4";
export var noCreateTagButton = "_fe-5";
export var tagsContainer = "_fe-6";
export var tagsModalContentContainer = "_fe-8";